




















import Vue from 'vue'
import TplList from './TplList.vue';
import commonVuex from '@/common/vuex/common'

export default Vue.extend({
  mixins: [commonVuex],
  components: {
    TplList,
  },
  computed: {
    hasFunc(): boolean {
      const funcInfo = this.account.funcInfo || '[]'
      let found = false
      Object.entries(JSON.parse(funcInfo) as any).forEach(([k, v]) => {
        const id = (v as any)['funcscope_category']['id']
        if(id === 89) {
          found = true
        }
      })
      return found
    },
  },
  methods: {
    addAuth() {
      window.open('https://weixin.drip.im/wx-member/auth?origin=' + encodeURIComponent('http://crm.drip.im/api-crm-web/auth/dripCrmAuthCallback') + '&authType=1');
    },
  },
})
